import { useCallback, useEffect, useState } from "react";
import { getFooterURL, putFooterURL } from "../../utils/ConstantsURL";

export const useFooterStyles = (token, documentId) => {
  const [footerStyles, setFooterStyles] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);

  const refresh = useCallback(() => setRefreshIndex((p) => p + 1), []);

  useEffect(() => {
    if (!token || !documentId) return;
    const controller = new AbortController();
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(getFooterURL(documentId), {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || data?.message || "Error");
        setFooterStyles(data);
      } catch (e) {
        if (e.name !== "AbortError") {
          console.error("useFooterStyles get:", e);
          setError(e.message || "Error al obtener footer");
        }
      } finally {
        setLoading(false);
      }
    };
    run();
    return () => controller.abort();
  }, [token, documentId, refreshIndex]);

  const updateFooterStyles = useCallback(
    async ({ active, position, font, color, fontSize, fontWeight, pleca, imageFile, image, width, height }) => {
      if (!documentId) {
        setError("ID de documento requerido");
        return { success: false, error: "ID de documento requerido" };
      }
      setSaving(true);
      setError(null);
      try {
        const form = new FormData();
        if (typeof active !== "undefined") form.append("active", String(active));
        if (position) form.append("position", position);
        if (font) form.append("font", font);
        if (color) form.append("color", color);
        if (typeof fontSize !== "undefined") form.append("fontSize", String(fontSize));
        if (fontWeight) form.append("fontWeight", fontWeight);
        if (pleca) form.append("pleca", pleca);
        if (typeof width !== "undefined" && width !== null && width !== "") {
          form.append("width", String(width));
        }
        if (typeof height !== "undefined" && height !== null && height !== "") {
          form.append("height", String(height));
        }
        if (imageFile instanceof File) {
          form.append("footerUpload", imageFile);
        } else if (image) {
          form.append("imageUrl", image);
        }

        const res = await fetch(putFooterURL(documentId), {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: form,
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || data?.message || "Error");
        setFooterStyles(data);
        return { success: true, data };
      } catch (e) {
        console.error("useFooterStyles put:", e);
        const msg = e.message || "Error al actualizar footer";
        setError(msg);
        return { success: false, error: msg };
      } finally {
        setSaving(false);
      }
    },
    [token, documentId]
  );

  return { footerStyles, setFooterStyles, loading, saving, error, refresh, updateFooterStyles };
};


